module.exports = __webpack_public_path__ + "static/img/68 (3).87db69c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/68 (3).jpg
// module id = GUd6
// module chunks = 0